import { connect } from 'react-redux';
import { clearOrderDetails } from '@app/actions/order_details';
import Const from '../../../config/const';
import ChatEnded from './chat_ended';
import { cancelChat, clearSumamryScreen } from '../../../actions/chat';
import { cancelVoipChat, clearVoipSumamryScreen } from '../../../actions/voip_chat';
import withPGTranslation from '../../../config/withPGTranslation';
import { clearAffiliatePromoPopup } from '../../../actions/affiliate_promo_popup';

const getFeedback = (order) => order && order.feedbackComment;
const getFeedbackIsPoste = (orderIdsSame, feedback) => orderIdsSame && !!feedback;

const mapStateToProps = ({
  orderDetails, chat, voipChat, user
}, { chatType }) => {
  switch (chatType) {
    case Const.chatType.text: {
      const { orderId } = chat;
      const order = (orderDetails && orderDetails[orderId]) || {};
      const orderIdsSame = ((order && order.id) || -1) === orderId;
      const feedback = getFeedback(order);
      const feedbackIsPosted = getFeedbackIsPoste(orderIdsSame, feedback);
      return {
        feedbackIsPosted,
        textChatReason: chat && chat.reason,
        user,
        ...chat,
        askForAdvisorBonus: order.askForAdvisorBonus || (typeof order.askForAdvisorBonus === 'undefined' && chat && chat.order && chat.order.askForAdvisorBonus),
        loading: orderDetails.loading
      };
    }
    case Const.chatType.voice:
    case Const.chatType.video: {
      const orderId = voipChat && voipChat.orderId;
      const order = (orderDetails && orderId && orderDetails[orderId]) || {};
      const orderIdsSame = ((order && order.id) || -1) === orderId;
      const feedback = getFeedback(order);
      const feedbackIsPosted = getFeedbackIsPoste(orderIdsSame, feedback);
      return {
        feedbackIsPosted,
        ...voipChat,
        ...voipChat.order,
        user,
        orderState: voipChat.order.state,
        askForAdvisorBonus: order.askForAdvisorBonus || (typeof order.askForAdvisorBonus === 'undefined' && voipChat.order && voipChat.order.askForAdvisorBonus),
        loading: orderDetails.loading
      };
    }
    default:
      return null;
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  switch (ownProps.chatType) {
    case Const.chatType.text:
      return ({
        cancelChat: () => dispatch(cancelChat()),
        clearAffiliatePromoPopup: () => dispatch(clearAffiliatePromoPopup()),
        clearSumamryScreen: () => dispatch(clearSumamryScreen()),
        clearOrderDetails: () => dispatch(clearOrderDetails())
      });
    case Const.chatType.voice:
    case Const.chatType.video:
      return ({
        cancelChat: () => dispatch(cancelVoipChat()),
        clearAffiliatePromoPopup: () => dispatch(clearAffiliatePromoPopup()),
        clearSumamryScreen: () => dispatch(clearVoipSumamryScreen()),
        clearOrderDetails: () => dispatch(clearOrderDetails())
      });
    default:
      return null;
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withPGTranslation(ChatEnded));
